import UpsellBanner from 'components/Common/UpsellBanner'
import UpsellModal from 'components/Common/UpsellModal'
import ModalContext from 'contexts/ModalContext'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import GeoContext from 'contexts/geoContext'
import useFlightDeals from 'hooks/Flights/useFlightDeals'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { sortBy } from 'lib/array/arrayUtils'
import { useCallback, useContext, useMemo } from 'react'
import React from 'react'

interface Props {
  originAirportCode: string;
  destinationAirportCode: string;
  packageView?: App.BedbankOfferPackageView;
  offer?: App.BedbankOffer
}

function BedbankOfferFlightDealBanner(props: Props) {
  const {
    destinationAirportCode,
    originAirportCode,
    packageView,
    offer,
  } = props
  const [deals] = useFlightDeals('all', {
    originAirportCode,
    destinationAirportCode,
  })
  const showModal = useContext(ModalContext)
  const dispatch = useOfferPageDispatch()
  const { isTaxExclusiveRegion } = useContext(GeoContext)

  const activeDeal = useMemo(() => {
    return sortBy(deals, (deal) => deal.hierarchy, 'asc')[0]
  }, [deals])

  const activeRate = packageView?.rates[0]
  const hotelTotalPrice = isTaxExclusiveRegion ? activeRate?.totals.exclusive : activeRate?.totals.inclusive

  const locationCaption = offer?.property.locationTitleOverride ?
    offer.property.locationTitleOverride :
      [offer?.property.address.city, offer?.property.address.stateProvinceName]
        .filter(Boolean)
        .join(', ')

  const showBanner = activeDeal && activeRate?.nights && packageView && hotelTotalPrice

  const handleShowUpsellBanner = useCallback(async() => {
    if (!showBanner) return

    const hasAgreed = await showModal<boolean>(
      <UpsellModal
        carrierName={activeDeal.carrier.name}
        carrierLogo={activeDeal.carrier.logo?.url}
        destinationName={locationCaption}
        price={hotelTotalPrice + activeDeal.perAdultPrice * 2}
        travelClass={activeDeal.fareClass}
        nights={activeRate.nights}
        travelPeriods={activeDeal.travelPeriods}
        salesEndDate={activeDeal.salesEndDate}
      />,
    )

    if (hasAgreed) {
      dispatch({ type: OfferPageActions.toggleFilter, filter: 'datepicker' })
    }
  }, [activeDeal, showModal, locationCaption, hotelTotalPrice, activeRate?.nights, dispatch, showBanner])

  if (!showBanner) {
    return null
  }

  return (
    <UpsellBanner
      carrierLogo={activeDeal.carrier.logo?.url}
      carrierName={activeDeal.carrier.name}
      destinationName={locationCaption}
      price={hotelTotalPrice + activeDeal.perAdultPrice * 2}
      onViewDetails={handleShowUpsellBanner}
      nights={activeRate.nights}
    />
  )
}

export default withOfferPageAndReduxState(
  (state) => ({
    offer: state.bedbankOffer,
  }),
)(BedbankOfferFlightDealBanner)
